if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"dashboard","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(1(333|473|601|816|864)|2(029|365|875)|3(21|423|891|959)|5((11|17|36)5|209|561|796|847|958)|6(3(67|83|89)|(40|88|98)1|259)|7(2(00|16|64)|373|399)|9(175|41|427|63)|4134|4651)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}